module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAsElEQVRoge2Wyw7CMAwEdxH//8vLhaAIOJDUj1bsnHJpvFOrtQFjjDHGGGOMMcYY84+woIYk/VSHXI9zW35iA5LKurtEQFKaRIkAkCdRJgDkSJQKAPES5QJArESLABAn0SYAxEi0CgDHJaom8Wfh71N3Oc99I9A2JDHLvK8Yp10lgFd4jpCX+ohH+Iy7q3YhzufILqQLZL35QdckDutC+xw4SulvdObZBY1zVw5jTDMPfcpUIhOcQKYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/CUR_STD.png
// module id = 51
// module chunks = 0